// See the "Facebook Case Study" answer for details about this implementation:
// https://stackoverflow.com/questions/31402576/enable-focus-only-on-keyboard-use-or-tab-press

export default {
    init() {
        document.body.addEventListener('mousedown', function() {
            document.body.classList.add('using-mouse');
        });
        document.body.addEventListener('keydown', function() {
            document.body.classList.remove('using-mouse');
        });
    }
}
